import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { EditorState } from 'lexical';
import { useEffect, useRef } from 'react';
import { useEditModeContext } from './EditModeContextPlugin';

type Props = {
  onStopEditing: (state: EditorState) => void;
};

export function EditorStopEditingPlugin(props: Props): null {
  const { onStopEditing } = props;
  const callbackRef = useRef(onStopEditing);
  callbackRef.current = onStopEditing;

  const [editor] = useLexicalComposerContext();
  const editable = useEditModeContext();

  useEffect(() => {
    return () => {
      callbackRef.current(editor.getEditorState());
    };
  }, [editor, editable]);

  return null;
}
